<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <div  class="div-query-banner"  >
            <a-form-item label="状态">
              <j-dict-select-tag  dictCode="projectdaily_approvalstatus"  v-model="queryParam.processState" ></j-dict-select-tag>
            </a-form-item>
          <a-button class="query-banner-btn" type="primary" @click="searchQuery" icon="search">查询</a-button>
          <a-button class="query-banner-btn" type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
        </div>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
        class="components-table-demo-nested"
        @expand="expand"
      >
      <div class="detail-div" slot="detail" slot-scope="text, record" >
        <template  v-for="item in record.sub"  >
          <span  class="detail-item" :key="item.id" > {{item.projectName}} :  {{item.useTime}}小时</span>
        </template>
      </div>
      <div  slot="processState" slot-scope="text" >
        <span  v-if="text==='pass'" class="green-color" >通过</span>
      </div>
      </a-table>
    </div>

    <busDailyReport-modal ref="modalForm" @ok="modalFormOk"></busDailyReport-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import BusDailyReportModal from './modules/BusDailyReportModal'
import { getAction } from '@/api/manage'

export default {
  name: 'BusDailyReportList',
  mixins: [JeecgListMixin],
  components: {
    BusDailyReportModal,
  },
  data() {
    return {
      description: '日报主表管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key:'rowIndex',
          width:60,
          align:"center",
          customRender:function (t,r,index) {
            return parseInt(index)+1;
          }
        },
        {
          title: '员工姓名',
          align: 'center',
          dataIndex: 'employeeName',
          key:'employees'
        },
        {
          title: '时间',
          align: 'center',
          dataIndex: 'createTime',
          customRender: function (text) {
            return !text ? "" : (text.length > 10 ? text.substr(0, 10) : text)
          }
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'processState',
          scopedSlots: { customRender: 'processState' },
        },
        {
          title: '总工时',
          align: 'center',
          dataIndex: 'allUseTime',
          customRender: function (text,r) {
            let allTime = r.sub.reduce((total,item)=>total+item.useTime,0)
            return allTime+"小时"
          }
        },
        {
          title: '明细',
          align: 'center',
          dataIndex: '明细',
          scopedSlots: { customRender: 'detail' },
        },
      ],
      url: {
        list: '/dailyproject/busDailyReport/list',
        delete: '/dailyproject/busDailyReport/delete',
        deleteBatch: '/dailyproject/busDailyReport/deleteBatch',
        exportXlsUrl: '/dailyproject/busDailyReport/exportXls',
        importExcelUrl: 'dailyproject/busDailyReport/importExcel',
      },
      dictOptions: {},
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
    //监控点击展开 expanded判断是否展开true或者false record父表信息
     expand(expanded,record){
      console.log(expanded,record)
    },  
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
  /deep/ .ant-table td { 
    white-space: nowrap; 
  }
  /deep/ .ant-table th { 
    white-space: nowrap; 
  }
  .div-query-banner{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  & >*:nth-child(n){
    width:370px;
  }
  &>*:nth-child(n+2){
    margin-left: 12px;
  }
  &>.query-banner-btn:nth-child(n){
    width:100px
  }
  .margin-left-auto{
    margin-left: auto;
  }
}
.comple-state-green{
  color: green;
}
.comple-state-red{
  color: red;
}
.detail-div{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  .detail-item{
    color: #FFFFFF;
    background: #afafaf;
    margin-right:10px;
    padding:4px 10px;
    border: 1px solid #fafafa;
    border-radius: 10px;
  }
}
.green-color{
  color: green;
}
</style>